import Navbar from "../Components/Header/Navbar";
import background from "../img/Background-header.jpg";
import device from "../img/Renders_Wizard/render15.png";
import { DeviceResistance } from "../Components/Product/DeviceResistance";
import Footer from "../Components/Footer/Footer";
import { Camera } from "../Components/Product/Camera";
import { useTranslation } from "react-i18next";
export const Product = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-white">
      {/* Navigation */}
      <Navbar />

      {/* Hero Section */}
      <div className="relative">
        {/* Background with overlay */}
        <div
          className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/30 z-0"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
          }}
        />

        {/* Hero Content */}
        <div className="relative z-10 min-h-[65vh] sm:min-h-screen flex items-center justify-center px-4 sm:px-8 lg:px-12 pt-16 pb-12 sm:pt-24">
          <div className="container mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
              {/* Product Image */}
              <div className="w-full lg:w-1/2 flex justify-center transform transition-all duration-500 hover:scale-105">
                <img
                  src={device}
                  alt="Wizard Device"
                  className="max-h-[60vh] object-contain drop-shadow-2xl"
                />
              </div>

              {/* Product Description */}
              <div className="w-full lg:w-1/2 text-center lg:text-left mt-8 lg:mt-0">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
                  {t("product.title")}{" "}
                  <span className="text-purple-300">
                    {" "}
                    {t("product.highlight")}
                  </span>{" "}
                  {t("product.second_title")}
                </h1>
                <p className="text-lg sm:text-xl text-gray-200 mb-8 max-w-2xl mx-auto lg:mx-0">
                  {t("product.description")}
                </p>
                {/* <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <button className="px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
                    {t("product.buttons.requestDemo")}
                  </button>
                  <button className="px-8 py-3 border-2 border-white text-white hover:bg-white/10 font-semibold rounded-lg transition-all duration-300">
                    {t("product.buttons.technicalSpecifications")}
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Features Sections */}

      {/* <div className="py-20 px-4 sm:px-8 lg:px-12 bg-gray-50"> */}
      <Camera />
      {/* </div> */}
      {/* <div className="py-20 px-4 sm:px-8 lg:px-12 "> */}
      <DeviceResistance />
      {/* </div> */}

      {/* Footer */}
      <Footer />
    </div>
  );
};
